import { Injectable } from '@angular/core';
import { Order } from 'src/app/shared/models/interfaces/order';
import { resolve } from 'dns';
import { promise } from 'protractor';
import { Messages } from 'src/app/shared/models/enums/messages';

@Injectable({
  providedIn: 'root'
})
export class OrdersService {

  // ______properties
  public orders:Order[] = [];
  public ordersIds:string[] = [];
  
  // _____Booleans

  constructor() {

    let storgeOrders = this.orders = JSON.parse(localStorage.getItem("orders"));
    let storgeOrdersIds = this.ordersIds = JSON.parse(localStorage.getItem("ordersIds"));


    if (storgeOrders) {
      this.orders = storgeOrders;
    } else {
      this.orders = [];      
    }

    if (storgeOrdersIds) {
      this.ordersIds = storgeOrdersIds;
    } else {
      this.ordersIds = [];      
    }
    
  }


  /**
   * add order
   * @param order 
   */ 
  addOrder(order: Order){
    this.orders.push(order);
    this.ordersIds.push(order.item_id);
    this.saveOrders();
  }

  /**
   * edit order 
   * @param orderId 
   * @param orderUpdated 
   */
  editOrder(orderId: string, orderUpdated: Order){
    let index = this.orders.findIndex(order => {
     return order.item_id === orderId
    });

    this.orders[index] = orderUpdated;
    this.saveOrders();
  }

  

  /**
   * delete order
   * @param orderId
   */
  deleteOrder(orderId: string) : Promise<Messages> {

    return new Promise((resolve , reject) => {

      this.orders = this.orders.filter(order => {
        return order.item_id !== orderId 
      });

      this.ordersIds = this.ordersIds.filter(id => {
        return id !== orderId
      });
  
      this.saveOrders();
      if (this.orders.length == 0) {
        localStorage.removeItem("orders");
        localStorage.removeItem("ordersIds");
      }

      let canceled ="The item canceled successfully"

      resolve(Messages.canceled);
      reject(Messages.error);

    });

  }

  


  

  // save order in localStorage
  private saveOrders() {
    localStorage.setItem("orders", JSON.stringify(this.orders))
    localStorage.setItem("ordersIds", JSON.stringify(this.ordersIds))
  }


  /**
   * check if order is Exist
   * @param itemId 
   */
  isOrderExist(itemId: string) : boolean {
    if ( this.ordersIds.includes(itemId) ) {
      return true;
    } else {
      return false
    }
  }



  /** 
   * get order quantity
   * @param orderId 
   */
  getOrderQuantity(orderId: string) : number {
    return this.orders.find(order => {
     return order.item_id === orderId
    }).quantity 
  };


  /**
   * update order quantity
   * @param orderId 
   * @param value 
   */
  updateOrderQuantity(orderId: string, value: number) {
    this.orders.find(order => {
      return order.item_id === orderId
     }).quantity = value
     
    this.saveOrders();
  }


  updateOrderTotalPrice(orderId: string, value: number) {
    this.orders.find(order => {
      return order.item_id === orderId
     }).totalPrice = value
     
    this.saveOrders();
  }


  

}
